/**
 * GoKwik Buy Now + free-gift app bridge.
 * Default GoKwik Buy Now clears cart, adds only the selected variant, then
 * opens checkout immediately — free-gift apps (DR Free Gift / CartKing) never
 * get time to inject the gift (esp. on iOS). This replaces Buy Now with:
 * clear → add product (with qty) → wait for free gift → GoKwik cart checkout.
 *
 * Offer: qty 2 → 1 free, qty 3 → 2 free (free = paidQty - 1 when paidQty >= 2).
 */
(function () {
  if (window.__oybGokwikBuyNowGiftInit) return;
  window.__oybGokwikBuyNowGiftInit = true;

  var WAIT_MS = 6000;
  var POLL_MS = 250;
  var inFlight = false;

  function ensureStyles() {
    if (document.getElementById('oyb-buynow-loader-style')) return;
    var style = document.createElement('style');
    style.id = 'oyb-buynow-loader-style';
    style.textContent = [
      '.pdp-buy-now-trigger,.stickyBuyNow,#gokwik-buy-now{position:relative;}',
      '.oyb-buynow-btn-loader{display:none;position:absolute;inset:0;align-items:center;justify-content:center;gap:8px;background:inherit;border-radius:inherit;z-index:2;}',
      '.pdp-buy-now-trigger.is-loading .oyb-buynow-btn-loader,',
      '.stickyBuyNow.is-loading .oyb-buynow-btn-loader,',
      '#gokwik-buy-now.is-loading .oyb-buynow-btn-loader{display:flex;}',
      '.pdp-buy-now-trigger.is-loading > :not(.oyb-buynow-btn-loader),',
      '.stickyBuyNow.is-loading > :not(.oyb-buynow-btn-loader),',
      '#gokwik-buy-now.is-loading > :not(.oyb-buynow-btn-loader){visibility:hidden;}',
      '.oyb-buynow-btn-loader__spin{width:16px;height:16px;border-radius:50%;border:2px solid rgba(255,255,255,.35);border-top-color:currentColor;animation:oybBuyNowSpin .7s linear infinite;flex-shrink:0;}',
      '.oyb-buynow-btn-loader__text{font-size:13px;font-weight:700;line-height:1;white-space:nowrap;}',
      '.pdp-buy-now-trigger.is-loading,.stickyBuyNow.is-loading,#gokwik-buy-now.is-loading{opacity:1 !important;pointer-events:none;cursor:wait !important;}',
      '@keyframes oybBuyNowSpin{to{transform:rotate(360deg);}}',
    ].join('');
    document.head.appendChild(style);
  }

  function ensureButtonLoader(btn) {
    if (!btn) return null;
    var existing = btn.querySelector(':scope > .oyb-buynow-btn-loader');
    if (existing) return existing;

    var loader = document.createElement('span');
    loader.className = 'oyb-buynow-btn-loader';
    loader.setAttribute('aria-hidden', 'true');
    loader.innerHTML =
      '<span class="oyb-buynow-btn-loader__spin"></span>' +
      '<span class="oyb-buynow-btn-loader__text">Please wait…</span>';
    btn.appendChild(loader);
    return loader;
  }

  function setButtonMessage(btn, text) {
    getTriggerButtons(btn).forEach(function (el) {
      var loader = ensureButtonLoader(el);
      if (!loader) return;
      var textEl = loader.querySelector('.oyb-buynow-btn-loader__text');
      if (textEl) textEl.textContent = text || 'Please wait…';
    });
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (path.indexOf('/') === 0) path = path.slice(1);
    return root + path;
  }

  function findProductForm(btn) {
    if (btn && btn.closest) {
      var scoped = btn.closest('product-form') || btn.closest('form[action*="/cart/add"]');
      if (scoped) {
        return scoped.tagName === 'FORM' ? scoped : scoped.querySelector('form');
      }
    }

    var sectionId = btn && btn.getAttribute && btn.getAttribute('data-section-id');
    if (sectionId) {
      var byId = document.getElementById('product-form-' + sectionId);
      if (byId) return byId;
    }

    return (
      document.querySelector('#pdp-atc-buttons')?.closest('form') ||
      document.querySelector('form[id^="product-form-"]') ||
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function readQuantity(form, btn) {
    // Sticky Buy Now uses #stquantity — sync/read it first when that trigger was used.
    var mainQty =
      (form && form.querySelector('input[name="quantity"]')) ||
      document.querySelector('input.mianQty[name="quantity"]') ||
      document.querySelector('form[id^="product-form-"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form]') ||
      document.getElementById('stquantity');

    var q = 1;
    if (btn && btn.classList && btn.classList.contains('stickyBuyNow')) {
      var stickyQty = document.getElementById('stquantity');
      if (stickyQty && stickyQty.value) {
        var sq = parseInt(stickyQty.value, 10);
        if (sq > 0) q = sq;
      }
    } else if (mainQty) {
      q = parseInt(mainQty.value, 10);
      if (!(q > 0)) q = 1;
    }

    // Cap only when product has a max set (e.g. site max 2). D3+K2 has no max.
    var parsedMax = mainQty
      ? parseInt((mainQty.dataset && mainQty.dataset.max) || mainQty.getAttribute('max') || '', 10)
      : NaN;
    if (!isNaN(parsedMax) && parsedMax > 0 && q > parsedMax) q = parsedMax;
    return q;
  }

  function readVariantId(form) {
    if (!form) return null;
    var input =
      form.querySelector('input[name="id"]:not([disabled])') ||
      form.querySelector('select[name="id"]') ||
      document.querySelector('.product-variant-id:not([disabled])');
    if (!input) return null;
    return input.value;
  }

  function expectedFreeQty(paidQty) {
    paidQty = Number(paidQty) || 1;
    // Current offer: 2 → 1 free, 3 → 2 free (free = paid - 1 when paid >= 2).
    if (paidQty >= 2) return paidQty - 1;
    return 0;
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    if (Number(item.final_line_price) === 0 || Number(item.line_price) === 0 || Number(item.price) === 0) {
      return true;
    }
    var props = item.properties || {};
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var key = String(keys[i]).toLowerCase();
      var val = String(props[keys[i]] == null ? '' : props[keys[i]]).toLowerCase();
      if (
        key.indexOf('gift') !== -1 ||
        key.indexOf('free') !== -1 ||
        key.indexOf('_attribution') !== -1 ||
        key.indexOf('drfg') !== -1 ||
        key.indexOf('cartking') !== -1 ||
        val.indexOf('gift') !== -1 ||
        val.indexOf('free') !== -1
      ) {
        return true;
      }
    }
    var title = String(item.product_title || item.title || '').toLowerCase();
    return title.indexOf('free gift') !== -1 || title.indexOf('free sample') !== -1;
  }

  function giftQuantity(items) {
    var total = 0;
    (items || []).forEach(function (item) {
      if (isFreeGiftItem(item)) total += Number(item.quantity) || 0;
    });
    return total;
  }

  function cartQuantity(items) {
    var total = 0;
    (items || []).forEach(function (item) {
      total += Number(item.quantity) || 0;
    });
    return total;
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res.json();
    });
  }

  function waitForFreeGift(paidQty) {
    var expected = expectedFreeQty(paidQty);
    // If expected free qty is 0 (ex: paidQty = 1), some offers still
    // add free gifts based on the selected variant (Bottle 2 / Bottle 3).
    // So we still wait briefly for gifts to appear.
    var firstGiftAt = null;

    var started = Date.now();
    var maxWait = expected > 0 ? Math.max(WAIT_MS, 2500 + expected * 1500) : WAIT_MS;

    function poll() {
      return fetchCart().then(function (cart) {
        var items = (cart && cart.items) || [];
        var gifts = giftQuantity(items);
        var total = cartQuantity(items);

        if (expected > 0) {
          // Gift lines present, or total qty grew to paid + expected free.
          if (gifts >= expected || total >= paidQty + expected) return cart;
        } else {
          // paidQty = 1: wait until at least 1 gift line appears, then allow
          // a short grace period for 2nd gift injection.
          if (gifts > 0 && firstGiftAt == null) firstGiftAt = Date.now();
          if (gifts > 0 && firstGiftAt != null && Date.now() - firstGiftAt >= 800) return cart;
        }
        if (Date.now() - started >= maxWait) return cart;
        return sleep(POLL_MS).then(poll);
      });
    }

    // Give gift apps a beat to react to /cart/add.js (important on iOS).
    return sleep(500).then(poll);
  }

  function getTriggerButtons(btn) {
    var buttons = [];
    document.querySelectorAll('.pdp-buy-now-trigger, .stickyBuyNow, #gokwik-buy-now').forEach(function (el) {
      buttons.push(el);
    });
    if (btn && buttons.indexOf(btn) === -1) buttons.push(btn);
    return buttons;
  }

  function setButtonLoading(btn, loading, text) {
    getTriggerButtons(btn).forEach(function (el) {
      if (!el) return;
      ensureButtonLoader(el);
      var gkLoader = el.querySelector('.addloadr, #btn-loader');
      if (loading) {
        el.disabled = true;
        el.classList.add('disabled', 'gokwik-disabled', 'is-loading');
        el.style.cursor = 'wait';
        el.setAttribute('aria-busy', 'true');
        if (gkLoader) gkLoader.style.display = 'none';
      } else {
        el.disabled = false;
        el.classList.remove('disabled', 'gokwik-disabled', 'is-loading');
        el.style.cursor = 'pointer';
        el.removeAttribute('aria-busy');
        if (gkLoader) gkLoader.style.display = 'none';
      }
    });
    if (loading) setButtonMessage(btn, text || 'Please wait…');
  }

  function openGokwikCheckout(btn) {
    if (typeof window.onCheckoutClick === 'function') {
      window.onCheckoutClick(btn);
      return true;
    }
    if (typeof window.gokwikCheckoutClickFn === 'function') {
      window.gokwikCheckoutClickFn(btn);
      return true;
    }
    var checkoutBtn = document.querySelector('.gokwik-checkout button');
    if (checkoutBtn) {
      checkoutBtn.click();
      return true;
    }
    return false;
  }

  function notifyCartUpdated() {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:change'));
      window.dispatchEvent(new Event('cart:updated'));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gokwik-buy-now-freegift' });
      }
    } catch (e) {}
  }

  async function buyNowWithFreeGift(btn) {
    if (inFlight) return;

    // Do NOT bail when #gokwik-buy-now is still disabled — custom PDP/sticky
    // triggers own the click and pass that hidden button as a handle.
    if (
      btn &&
      (btn.classList.contains('pdp-buy-now-trigger') || btn.classList.contains('stickyBuyNow')) &&
      (btn.disabled || btn.getAttribute('disabled') != null)
    ) {
      return;
    }

    inFlight = true;
    ensureStyles();
    setButtonLoading(btn, true, 'Please wait…');

    try {
      var form = findProductForm(btn);
      if (!form) throw new Error('Product form not found');

      // Keep sticky qty in sync with main form before reading.
      var stickyQty = document.getElementById('stquantity');
      var mainQtyInput =
        form.querySelector('input[name="quantity"]') ||
        document.querySelector('input.mianQty[name="quantity"]');
      if (btn && btn.classList.contains('stickyBuyNow') && stickyQty && mainQtyInput) {
        mainQtyInput.value = stickyQty.value;
      }

      var variantId = readVariantId(form);
      var qty = readQuantity(form, btn);
      if (!variantId) throw new Error('Variant id missing');

      // Match GoKwik Buy Now: start from an empty cart, then add this product.
      setButtonMessage(btn, 'Preparing…');
      await fetch(cartUrl('cart/clear.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      setButtonMessage(btn, 'Adding…');
      var addUrl = (window.routes && window.routes.cart_add_url) || cartUrl('cart/add.js');

      // Explicit JSON add so quantity is never dropped (qty input sits outside <form>).
      var addRes = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: qty,
        }),
      });

      var addJson = await addRes.json().catch(function () {
        return null;
      });
      if (!addRes.ok || (addJson && addJson.status)) {
        throw new Error((addJson && (addJson.description || addJson.message)) || 'Add to cart failed');
      }

      notifyCartUpdated();

      setButtonMessage(btn, 'Applying gift…');
      await waitForFreeGift(qty);

      setButtonMessage(btn, 'Opening…');
      var opened = openGokwikCheckout(btn);
      if (!opened) {
        window.location.href = (window.routes && window.routes.cart_url) || cartUrl('cart');
      }
    } catch (err) {
      console.error('[OYB] Buy Now free-gift flow failed:', err);
      setButtonMessage(btn, 'Opening…');
      // Fallback: open checkout with whatever is in cart now.
      if (!openGokwikCheckout(btn)) {
        window.location.href = (window.routes && window.routes.cart_url) || cartUrl('cart');
      }
    } finally {
      // Keep button loader briefly so GoKwik popup can appear without a blank gap.
      setTimeout(function () {
        setButtonLoading(btn, false);
        inFlight = false;
      }, 1200);
    }
  }

  function patchBuyNow() {
    window.onBuyNowClick = function (btn) {
      buyNowWithFreeGift(btn);
    };

    // Expose for custom PDP / sticky triggers.
    window.oybBuyNowWithFreeGift = buyNowWithFreeGift;
    window.__oybBuyNowGiftPatched = true;
  }

  window.addEventListener('gokwikLoaded', patchBuyNow);

  // If GoKwik already loaded before this script, patch immediately.
  if (typeof window.onBuyNowClick === 'function' || typeof window.onCheckoutClick === 'function') {
    patchBuyNow();
  }

  // Safety: GoKwik can redefine handlers slightly after load on some devices.
  document.addEventListener('DOMContentLoaded', function () {
    ensureStyles();
    setTimeout(patchBuyNow, 0);
    setTimeout(patchBuyNow, 1500);
    setTimeout(patchBuyNow, 3000);
  });
})();
